export default __webpack_public_path__ + "static/webApplicationDevelopment-a77c4681a81ee9fe69e2e19523293fda.svg";